import { ChatMessage } from '../../types/agentChat';
import { ChatMessageAttachments } from './ChatMessageAttachments';

interface UserMessageProps {
  message: ChatMessage;
}

export function UserMessage({ message }: UserMessageProps) {
  return (
    <div className="max-w-10/12 justify-self-end">
      {/* Show attachments above user message */}
      {message.attachments && message.attachments.length > 0 && (
        <ChatMessageAttachments
          attachments={message.attachments}
          className="mb-2"
        />
      )}
      <div className="wrap-break-words rounded-xl bg-white px-4 py-3 whitespace-pre-wrap">
        {message.content}
      </div>
    </div>
  );
}
